import React from 'react';
import { Button } from 'react-bootstrap';
import { ImageModel, LinkModel } from '../../models/globals';

interface RtcBannerProps {
    rtcBannerCartIcon: ImageModel;
    rtcBannerArrowIcon: ImageModel;
    rtcBannerCloseIcon: ImageModel;
    isRtcBannerFeatureFlagEnabled: boolean;
    shoppingCartCount: number;
    shoppingCartLink: LinkModel;
}

const RtcBanner: React.FC<RtcBannerProps> = ({
    rtcBannerCartIcon,
    rtcBannerArrowIcon,
    rtcBannerCloseIcon,
    isRtcBannerFeatureFlagEnabled,
    shoppingCartCount,
    shoppingCartLink,
}) => {
    const [showBanner, setShowBanner] = React.useState(
        typeof window !== 'undefined' ? !window.sessionStorage.getItem('rtcBannerSeen') : false,
    );
    const hideBanner = () => {
        if (typeof window !== 'undefined') window.sessionStorage.setItem('rtcBannerSeen', 'true');
        setShowBanner(() => false);
    };

    return (
        <>
            {isRtcBannerFeatureFlagEnabled && shoppingCartCount > 0 && showBanner && (
                <div className="rtc-banner">
                    <a href={shoppingCartLink.url} className="rtc-cart-img">
                        <img src={rtcBannerCartIcon.url} alt={rtcBannerCartIcon.altText} />
                    </a>
                    <div className="rtc-line-break"></div>
                    <div className="rtc-text">
                        <span className="bold">Forgot Something?</span>
                        <div className="rtc-subtext">
                            You have <span className="rtc-item-num">{shoppingCartCount}</span> <span>item</span>
                            <span>{shoppingCartCount > 1 && 's'}</span> left in your Shopping Cart
                        </div>
                    </div>
                    <a href={shoppingCartLink.url} className="rtc-checkout-btn">
                        Complete Checkout
                        <img className="rtc-arrow" src={rtcBannerArrowIcon.url} alt={rtcBannerArrowIcon.altText} />
                    </a>
                    <Button onClick={hideBanner} className="rtc-close">
                        <img src={rtcBannerCloseIcon.url} alt={rtcBannerCloseIcon.altText} />
                    </Button>
                </div>
            )}
        </>
    );
};

export { RtcBanner, RtcBannerProps };
